<template>
  <div class="effect-analysis" >
    <div class="analysis-head">
      <div class="analysis-head__num">02</div>
      <div class="analysis-head__title">学习效果分析</div>
    </div>
    <p class="analysis-head__info">* 仅统计测试薄弱且学完的知识点（测试后，未掌握的薄弱知识点，若没有完成学习，则不纳入学习的后统计）</p>
    <div class="analysis-content"
    >
      <div class="analysis-compare">学前学后知识点掌握情况对比</div>
      <div class="study-progress"
      v-if="effect.avg_ability_before!==-1&&effect.avg_ability_before"
      >
        <div class="study-before">
          <div class="study-before_btn">
            <img src="@/views/pt/images/study_before.png" alt=""></div>
          <div class="study-before_circle">
            <img src="@/views/pt/images/progress_bgc.png" alt="">
            <el-progress type="circle"
            :percentage="avg_ability_before>0?avg_ability_before:0" status="exception"
            :width="142" :height="142"
             class="progress_circle" :show-text="false"></el-progress>
            <p class="progress_rate">{{effect.avg_ability_before|dataFormat}}</p>
            <p class="progress_info">测试平均掌握程度</p>
            </div>
        </div>
        <div class="study-center">
          <div class="study-center_btn">
            <img src="@/views/pt/images/arrow_mark.png" alt="">
            <p class="study_status">通过学习阶段</p>
            <p v-if="improve > 0" class="study_master">提升平均掌握程度+{{improve|dataFormat}}</p>
            <p v-else class="study_master">提升平均掌握程度 0%</p>
          </div>
        </div>
        <div class="study-after">
           <div class="study-after_btn">
            <img src="@/views/pt/images/study_after.png" alt=""></div>
          <div class="study-after_circle">
            <img src="@/views/pt/images/progress_bgc.png" alt="">
            <el-progress type="circle" status="success"
            :percentage="avg_ability_after>0?avg_ability_after:0" :width="142" :height="142"
            :show-text="false" class="progress_circle"></el-progress>
            <p class="progress_rate">{{effect.avg_ability_after|dataFormat}}</p>
            <p class="progress_info">学后平均掌握程度</p>
            </div>
        </div>
      </div>
      <div v-else>
      <Empty content="暂无知识点学习数据～"/>
    </div>
    </div>
  </div>
</template>

<script>
import Empty from '@/views/pt/components/empty.vue';

export default {
  name: 'effectAnalysis',
  components: {
    Empty,
  },
  props: {
    effect: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
    };
  },
  filters: {
    dataFormat(msg) {
      return `${Math.floor(msg * 100)}%`;
    },
  },
  computed: {
    improve() {
      return this.effect.avg_ability_after - this.effect.avg_ability_before;
    },
    avg_ability_before() {
      return Number(Math.floor(this.effect.avg_ability_before * 100));
    },
    avg_ability_after() {
      return Number(Math.floor(this.effect.avg_ability_after * 100));
    },
  },
};
</script>

<style lang="scss" scoped>
.effect-analysis{
   padding-top:30px;
   padding-bottom:80px;
  .analysis-head{
    display: flex;
    align-items: center;
    margin-bottom:11px ;
    &__num{
      font-size: 22px;

      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      margin-right: 14px;
      background:url('~@/views/pt/images/class_bg.png');
      background-size:cover;
      width:38px;
      height:29px;
      text-align: center;
    }
    &__title{
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
    }
     &__info{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(17, 31, 44, 0.6);
    }
  }
  .analysis-compare{
    width: 231px;
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    margin: 30px auto;
    position: relative;
     &::before{
        position: absolute;
        content: "";
        left: 0px;
        top: 8px;
        width: 220px;
        height: 13px;
        background: rgba(230, 162, 60, 0.2);
        border-radius: 7px;
      }
  }
  .study-progress{
    display: flex;
    margin: 0 auto;
    width: 744px;
    .study-before{
      height: 260px;
      width: 202px;
      margin-right:59px ;
      .study-before_btn{
        img{
          margin: 27px 0 16px 48px ;
        }
      }
      .study-before_circle{
        position: relative;
        .progress_circle{
          position: absolute;
          top: 30px;
          left: 30px;
        }
        .progress_rate{
          position: absolute;
          top: 67px;
          left: 72px;
          font-size: 28px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.8);
          letter-spacing: 1px;
        }
         .progress_info{
          position: absolute;
          top: 109px;
          left: 42px;
          width: 112px;
          font-size: 14px;
          color: rgba(17, 31, 44, 0.6);
        }
      }
    }
    .study-center{
      padding-top: 176px;
      margin-right: 59px;
       position: relative;
        .study_status{
          position: absolute;
          top: 158px;
          left: 55px;
          font-size: 17px;
          color: rgba(17, 31, 44, 0.79);
        }
        .study_master{
          position: absolute;
          top: 185px;
          left: 20px;
          font-size: 17px;
          color: rgba(17, 31, 44, 0.79);
        }
    }
     .study-after{
      height: 260px;
      width: 202px;
      .study-after_btn{
        img{
          margin: 27px 0 16px 48px ;
        }

      }
      .study-after_circle{
        position: relative;
        .progress_circle{
          position: absolute;
          top: 30px;
          left: 30px;
        }
         .progress_rate{
          position: absolute;
          top: 67px;
          left: 72px;
          font-size: 28px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.8);
          letter-spacing: 1px;
        }
         .progress_info{
          position: absolute;
          top: 109px;
          left: 42px;
          width: 112px;
          font-size: 14px;
          color: rgba(17, 31, 44, 0.6);
        }
      }
    }
  }
  .knowledge-master{
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    display: inline-block;
    position: relative;
     &::before{
        position: absolute;
        content: "";
        left: 0px;
        top: 8px;
        width: 188px;
        height: 13px;
        background: rgba(230, 162, 60, 0.2);
        border-radius: 7px;
      }
  }
  .knowledge-info{
    width: 92px;
    height: 28px;
    border-radius: 17px;
    margin-left:12px ;
    border: 1px solid #1989FA;
    color: #1989FA;
  }
  .knowledge-detail{
    margin-left: 39px;
    margin-top: 64px;
    display: flex;
    .knowledge-info{
      width: 153px;
      height: 173px;
      background:
      linear-gradient(180deg, rgba(226, 245, 255, 0.32) 0%, rgba(206, 238, 255, 0.33) 100%);
      border-radius: 23px;
      opacity: 0.64;
      border: 2px dashed #E1F5FFFF;
      position: relative;
      .knowledge-num{
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #111F2C;
        position: absolute;
        top: 57px;
        left: 54px;
      }
      .knowledge-total{
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(17, 31, 44, 0.56);
        position: absolute;
        top: 99px;
        left: 24px;
      }
    }
  }
}
</style>
